<template>
    <div>
        <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                               :titleLabel="title"
                               :parentScreen="parentScreen">
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picZipCode">
                    {{$t('profile.label.pic_postal_code')}}
                </label>
                <div class="col-md-3">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picZipCode'].$model"
                           id="picZipCode"
                           name="picZipCode"
                           required
                           maxlength="7"
                           v-convert-fullwidth-to-halfwidth
                           @blur="searchZipCode('amsCustomerDetail.picZipCode','amsCustomerDetail.picPerfecture','amsCustomerDetail.picCity')"
                    >
                    <div v-if="$v.input['amsCustomerDetail.picZipCode'].$error || $v.input['amsCustomerDetail.picZipCode'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picZipCode'].requiredIf">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_postal_code')}) }}
                        </div>
                        <div v-if="$v.input['amsCustomerDetail.picZipCode'].requiredIf && !$v.input['amsCustomerDetail.picZipCode'].customerNumberValidation">
                            {{ $t('profile.error.invalid_number') }}
                        </div>
                    </div>
                </div>
                <label class="control-label col-md-3 col-form-label">
                    <a :href="hrefPostalCodeReference" target="_blank">
                        {{$t('profile.href.postal_code_reference')}}
                    </a>
                </label>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picPerfecture">
                    {{$t('profile.label.pic_perfecture')}}
                </label>
                <div class="col-md-6">
                    <select class="form-control"
                            v-model="$v.input['amsCustomerDetail.picPerfecture'].$model"
                            required
                            id="picPerfecture"
                            name="picPerfecture">
                        <option v-for="item in listPrefecture" :key="item.key" :value="item.key">
                            {{item.value}}
                        </option>
                    </select>
                    <div v-if="$v.input['amsCustomerDetail.picPerfecture'].$error || $v.input['amsCustomerDetail.picPerfecture'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picPerfecture'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_perfecture')}) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picCity">
                    {{$t('profile.label.pic_city')}}
                </label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picCity'].$model"
                           id="picCity"
                           name="picCity"
                           required
                           maxlength="100"
                           v-convert-halfwidth-to-fullwidth
                    >
                    <div v-if="$v.input['amsCustomerDetail.picCity'].$error || $v.input['amsCustomerDetail.picCity'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picCity'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_city')}) }}
                        </div>

                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picSection">
                    {{$t('profile.label.pic_section')}}
                </label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picSection'].$model"
                           id="picSection"
                           name="picSection"
                           required
                           maxlength="50"
                           v-convert-halfwidth-to-fullwidth
                    >
                    <div v-if="$v.input['amsCustomerDetail.picSection'].$error || $v.input['amsCustomerDetail.picSection'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.picSection'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.pic_section')}) }}
                        </div>

                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="picBuildingName">
                    {{$t('profile.label.pic_building_name')}}
                </label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.picBuildingName'].$model"
                           id="picBuildingName"
                           name="picBuildingName"
                           required
                           maxlength="50"
                           v-convert-halfwidth-to-fullwidth>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label">{{$t('profile.label.upload.title')}}</label>
                <div class="col-md-6">
                    <FileInput v-model="$v.fileCustomerPicAddress1.$model" name="fileCustomerPicAddress1"></FileInput>
                    <error-messages-block :field="$v.fileCustomerPicAddress1">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerPicAddress2.$model" name="fileCustomerPicAddress2"></FileInput>
                    <error-messages-block :field="$v.fileCustomerPicAddress2">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerPicAddress3.$model" name="fileCustomerPicAddress3"></FileInput>
                    <error-messages-block :field="$v.fileCustomerPicAddress3">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class='col-md-12'>
                    <div class="alert alert-warning">
                        <div>
                            {{$t('profile.pic.address.after_upload' )}}
                            <a :href="SUPPORT_DOCUMENT_URL" target="_blank">{{$t('profile.require.document')}}</a>
                            {{$t('profile.pic.address.after_upload_footer' )}}
                        </div>
                        <div>
                            {{$t('profile.pic.address.after_upload2' )}}
                            <a :href="SUPPORT_DOCUMENT_URL" target="_blank">{{$t('profile.require.document')}}</a>
                            {{$t('profile.pic.address.after_upload_footer' )}}
                        </div>
                        {{$t('profile.pic.address.after_upload_footer2' )}}
                    </div>
                </div>
            </div>

            <template v-if="this.isParentScreenEditProfile">
                <div class="form-action">
                    <button class="btn btn-sm btn-submit btn-success mr-2"
                            :disabled="isDisabledButtonSubmit && isInvalidFile"
                            :type="this.getButtonType()">
                        {{$t('profile.button.change')}}
                    </button>
                    <button class="btn btn-default btn-cancel btn-sm"
                            type="button"
                            @click="reverseInput">
                        {{$t('profile.button.cancel')}}
                    </button>
                </div>
            </template>
        </ForceNewsBlockWrapper>
    </div>
</template>

<script>
/**
 * @author HungNS
 */
import {customerNumberValidation} from '@/common/helpers/validation'
import {createNamespacedHelpers} from 'vuex';
import formMixin from '@/common/mixins/form';
import {required, requiredIf} from 'vuelidate/lib/validators'

const {mapGetters: mapForceNewsGetters} = createNamespacedHelpers("forceNews");
    export default {
        name: "UpdateCustomerPicAddress",
        props: {},
        mixins: [formMixin],
        data: function () {
            const {IConstants} = this;
            const hrefPostalCodeReference = IConstants.HREF_POSTAL_CODE_REFERENCE;
            return {
                hrefPostalCodeReference,
                fileCustomerPicAddress1: null,
                fileCustomerPicAddress2: null,
                fileCustomerPicAddress3: null
            }
        },
        computed: {
            SUPPORT_DOCUMENT_URL() {
                return this.$store.state[this.namespace].SUPPORT_DOCUMENT_URL
            },
            title() {
                let result = this.$t('profile.label.pic_address');
                return result;
            },
            fileUploadExt() {
                return this.$store.state.header.headerInfo.fileUploadExt
            },
            fileTypeExtension() {
                return this.fileUploadExt.toUpperCase();
            },
            isInvalidFile(){
              const {$v} = this;
              return $v.$anyError || (this.fileCustomerPicAddress1 === null && this.fileCustomerPicAddress2 === null && this.fileCustomerPicAddress3 === null);
            },
            ...mapForceNewsGetters(['listPrefecture'])

        },
        validations() {
            const initValidationFileData = this.getInitFileValidation({...this.$data}, ['hrefPostalCodeReference'],undefined, true);
            return {
                input: {
                    'amsCustomerDetail.picZipCode': {
                        requiredIf: requiredIf(function () {
                            return this.input['amsCustomerDetail.picZipCode'] !== null
                        }),
                        customerNumberValidation
                    },
                    'amsCustomerDetail.picPerfecture': {
                        required,
                    },
                    'amsCustomerDetail.picCity': {
                        required,
                    },
                    'amsCustomerDetail.picSection': {
                        required,
                    },
                    'amsCustomerDetail.picBuildingName': {},

                },
                ...initValidationFileData
            }
        },
        methods: {
            searchZipCode: function (zipCodeKey, prefectureKey, cityKey) {
                let zipCode = this.input[zipCodeKey];
                const params = {
                    'zipCode': zipCode
                };
                let self = this;
                this.$service.getService("forceNews").searchZipCode(params).then( response => {
                    if (response.prefecture) self.input[prefectureKey] = response.prefecture;
                    if (response.prefecture && response.section) self.input[cityKey] = response.city + '　' + response.section;
                    self.$v.$touch();
                })
            },
        }
    }
</script>

<style scoped>

</style>
